// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"173":"1e66f9f4","634":"20c0d083","971":"4186d1de"}[chunkId] + ".chunk.css";
};